import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { IEditLedger } from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useEditLedger(campaignInfluencerId: string) {
  const {
    mutate: editLedger,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation<IEditLedger>({
    mutationFn: async (ledger) => {
      return await CampaignService.editLedger(ledger).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    editLedger,
    isEditing,
    isEdited,
  };
}
